import cookies from '@/plugins/cookies'

const referralCookie = 'referral-token'

export default function () {
  return cookies.get(referralCookie) || ''
}
